@let isMobile = breakpoints() === "mobile";
<section [ngClass]="['gallery-layout', 'gallery-layout-16', backgroundClass()]">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-lg-12">
        @if (subtitle(); as subtitle) {
          <app-title [titles]="[subtitle]" />
        }
        <div class="content-header">
          @if (title(); as title) {
            <app-title [titles]="[title]" class="title" />
          }
          @if (data().text || data().cta) {
            <div class="content-details">
              @if (data().text; as text) {
                <div [innerHTML]="text" class="text"></div>
              }
              @if (data().cta; as cta) {
                @let store = uuid();
                <app-button
                  [theme]="isLightBackground() ? 'TRANSPARENT_BLACK' : 'WHITE'"
                  [routerLink]="cta.url"
                  [label]="cta.label"
                  [queryParams]="store ? { store } : {}" />
              }
            </div>
          }
        </div>
      </div>
      @if (!isMobile && data().items.length > DEFAULT_ITEMS_PER_VIEW_DESKTOP) {
        <div class="col-lg-12">
          <div class="list-controls">
            <i
              (click)="onPrev(data().items.length / DEFAULT_ITEMS_PER_VIEW_DESKTOP)"
              [color]="isLightBackground() ? 'GREY_LIGHT' : 'WHITE'"
              iconName="ARROW_BIG_LEFT"
              size="3.2rem"
              class="list-controls-left"></i>
            <i
              (click)="onNext(data().items.length / DEFAULT_ITEMS_PER_VIEW_DESKTOP)"
              [color]="isLightBackground() ? 'GREY_LIGHT' : 'WHITE'"
              iconName="ARROW_BIG_RIGHT"
              size="3.2rem"
              class="list-controls-right"></i>
          </div>
        </div>
      }
      <div class="col-xs-12 col-lg-12">
        <ul #listElement class="list">
          @for (item of data().items; track item) {
            <li class="list-item">
              <figure class="figure">
                @if (item.image; as image) {
                  <app-image [image]="image" [size]="{ dw: 384, dh: 480, mw: 157, mh: 196 }" class="img" />
                }
                @if (item.price) {
                  <figcaption>
                    <hr class="separator" />
                    @if (isMobile) {
                      <span class="title">{{ item.title }}</span>
                      <span class="subtitle">{{ item.subtitle }}</span>
                      <span [innerHTML]="item.price" class="price"></span>
                    } @else {
                      <div class="title-price">
                        <span class="title">{{ item.title }}</span>
                        <span [innerHTML]="item.price" class="price"></span>
                      </div>
                      <span class="subtitle">{{ item.subtitle }}</span>
                    }
                  </figcaption>
                }
              </figure>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</section>
